<div>
  @if (componentData.name === 'FaceBook') {
    <div>
      <hr>
      </div>
    }
    <div>
      @if (componentData.name === 'FaceBook') {
        <div class="mr-4 d-inline-flex h1 text-cls">Share
        </div>
      }
      <div class="d-inline-flex">
        <div >
          <a href="{{componentData.url}}" target="_blank" class="h4 mb-0 nav-link1 secondary-anchor custom-align-center"><i
          class="fab fa-facebook-f"></i>
        </a>
      </div>
      <div >
        <a class="social-icon" target="_blank" class="h4 mb-0 nav-link1 secondary-anchor custom-align-center" href="https://www.twitter.com/company/siemensgamesa" target="_blank">
          <i class="fa-brands fa-x-twitter"></i>
        </a>
      </div>
      <div >
        <a class="social-icon" target="_blank"class="h4 mb-0 nav-link1 secondary-anchor custom-align-center"  href="https://www.instagram.com/company/siemensgamesa" target="_blank" role="button">
          <i class="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  </div>
</div>


